import { Location } from "@angular/common";
import { Component, OnInit, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { BookletDialogComponent } from "@shared/dialogs/booklet-dialog/booklet-dialog.component";
import { SellerDTO } from "@shared/model/seller.model";
import { UserDTO } from "@shared/model/user.model";
import { UserApiService } from "@shared/services/users/userApi.service";
import { UsersService } from "@shared/services/users/users.service";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { take } from "rxjs/operators";

@Component({
	selector: "app-post-sales",
	templateUrl: "./post-sales.component.html",
	styleUrl: "./post-sales.component.scss",
	standalone: false
})
export class PostSalesComponent implements OnInit {
	wcmService = inject(WcmService);
	private userApiService = inject(UserApiService);
	private userService = inject(UsersService);
	private location = inject(Location);
	private dialog = inject(MatDialog);

	seller: SellerDTO;
	isAdmin: boolean;
	user: UserDTO;
	dialogConfig = new MatDialogConfig();

	constructor() {
		this.userService
			.getProfileOfLoggedUser()
			.pipe(take(1))
			.subscribe(value => {
				this.user = value;
			});
	}

	ngOnInit() {
		this.userApiService
			.getReferenceSellerDealerUsingGET()
			.subscribe(value => {
				if (this.seller = value) {
					this.seller.note = this.seller.note?.replace(
						/(?:\r\n|\r|\n)/g,
						"<br>"
					) ?? "";
				}
			});

		this.userService.isAdmin().subscribe(value => {
			this.isAdmin = value;
		});
	}

	openBooklet() {
		this.dialogConfig.width = '500px';
		this.dialog.open(
			BookletDialogComponent,
			this.dialogConfig
		);
	}

	goBack() {
		this.location.back();
	}
}